module.exports = __webpack_public_path__ + "img/thumb_30.48c35a41.jpg";